import React, { useEffect, useState, createElement } from 'react';
import { Calendar, Lock, AlertTriangle, X } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  useEffect(() => {
    // Load Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'Lead');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/a72y8tn9om.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-243">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-244">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=Lead&noscript=1" alt="" data-id="element-245" />
      </noscript>

      {/* Green Header Banner */}
      <div className="bg-gradient-to-r from-green-600 to-green-500 py-4 md:py-6 px-4" data-id="element-246">
        <div className="max-w-4xl mx-auto text-center" data-id="element-247">
          <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-248">
            <Calendar className="w-6 h-6 md:w-8 md:h-8" data-id="element-249" />
            <h1 className="text-xs sm:text-sm md:text-lg lg:text-xl xl:text-2xl font-bold whitespace-nowrap" data-id="element-250">
              Reservada La Fecha: ENERO 13 | 7PM EST (Hora Miami)
            </h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-3xl mx-auto px-4 py-8 md:py-12" data-id="element-251">
        {/* Main Headline */}
        <div className="text-center mb-8 md:mb-12" data-id="element-252">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-2 flex items-center justify-center gap-2 flex-wrap" data-id="element-253">
            Tu Lugar Está Reservado Para El Creador Digital AI Workshop{' '}
            <Lock className="w-6 h-6 md:w-8 md:h-8" data-id="element-254" />
          </h2>
          <div className="w-full h-1 bg-gradient-to-r from-transparent via-white to-transparent mt-6" data-id="element-255"></div>
        </div>

        {/* Video Section */}
        <div className="mb-12 md:mb-16" data-id="element-256">
          <div className="border-4 border-yellow-500 rounded-lg overflow-hidden bg-black p-2 md:p-4" data-id="element-257">
            <div className="relative w-full" style={{
            paddingTop: '56.25%'
          }} data-id="element-258">
              <div className="absolute inset-0" data-id="element-259">
                <wistia-player media-id="a72y8tn9om" aspect="1.7777777777777777" className="w-full h-full" data-id="element-260"></wistia-player>
              </div>
            </div>
          </div>
        </div>

        {/* Step 1: Check Email */}
        <div className="mb-8 md:mb-12" data-id="element-261">
          <div className="bg-gray-700 rounded-full py-3 md:py-4 px-6 md:px-8 text-center mb-4 md:mb-6 inline-block w-full" data-id="element-262">
            <h3 className="text-xl md:text-2xl font-bold" data-id="element-263">
              Paso #1: Revisa Tu Email
            </h3>
          </div>

          <div className="bg-gray-800 border-2 border-gray-700 rounded-lg p-4 md:p-6 mb-4" data-id="element-264">
            <div className="flex items-center gap-3 mb-4" data-id="element-265">
              <AlertTriangle className="w-6 h-6 text-yellow-500 flex-shrink-0" data-id="element-266" />
              <p className="text-lg md:text-xl font-bold" data-id="element-267">
                Acción Necesaria Ahora
              </p>
            </div>
          </div>

          <div className="border-2 border-green-600 rounded-lg p-4 md:p-6 bg-black/50" data-id="element-268">
            <p className="text-base md:text-lg text-center leading-relaxed" data-id="element-269">
              Revisa tu email para confirmar tu acceso y continúa con los pasos
              siguientes para aprovechar al máximo el evento.
            </p>
          </div>
        </div>

        {/* Step 2: WhatsApp Group */}
        <div className="mb-8 md:mb-12" data-id="element-270">
          <div className="bg-gray-700 rounded-full py-3 md:py-4 px-6 md:px-8 text-center mb-4 md:mb-6 inline-block w-full" data-id="element-271">
            <h3 className="text-xl md:text-2xl font-bold" data-id="element-272">
              Paso #2: Únete Al Grupo De Whatsapp
            </h3>
          </div>

          <div className="mb-6" data-id="element-273">
            <a href="https://chat.whatsapp.com/DBtAvtgTtmUERL12dsdcm2" target="_blank" rel="noopener noreferrer" data-id="element-274">
              <img src="https://cdn.magicpatterns.com/uploads/ghsdhyPTPecHSEKySyrZZY/tmp78iwyukg.webp" alt="Únete a nuestro grupo de WhatsApp" className="w-full max-w-2xl mx-auto hover:scale-[1.02] transition-transform duration-300 cursor-pointer" data-id="element-275" />
            </a>
          </div>

          <p className="text-center text-base md:text-lg leading-relaxed px-4" data-id="element-276">
            Para aprovechar al máximo esta experiencia, únete ahora a nuestro
            grupo privado exclusivo para los asistentes
          </p>
        </div>

        {/* Step 3: Exclusive Gift */}
        <div className="mb-12 md:mb-16" data-id="element-277">
          <div className="bg-gray-700 rounded-full py-3 md:py-4 px-6 md:px-8 text-center mb-4 md:mb-6 inline-block w-full" data-id="element-278">
            <h3 className="text-xl md:text-2xl font-bold" data-id="element-279">
              Paso #3: Regalo Exclusivo
            </h3>
          </div>

          <div className="mb-6" data-id="element-280">
            <a href="https://ahora.truemarketer.com/guia-implementacion" target="_blank" rel="noopener noreferrer" data-id="element-281">
              <img src="https://cdn.magicpatterns.com/uploads/4zYTYSxszfNSjNEU1edQSz/tmp5djoo1mh.webp" alt="Regalo Gratis - Guía Completa de Implementación" className="w-full max-w-3xl mx-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300 cursor-pointer" data-id="element-282" />
            </a>
          </div>

          <p className="text-center text-base md:text-lg leading-relaxed px-4" data-id="element-283">
            Guía completa de implementación paso a paso para seguir lo que
            enseñaré en la masterclass en vivo de Infocommerce AI.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-8 md:py-12" data-id="element-284">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-285">
          <div className="mb-6" data-id="element-286">
            <p className="text-green-500 font-bold text-lg md:text-xl mb-2" data-id="element-287">
              INFOCOMMERCE.AI
            </p>
          </div>

          <div className="text-gray-400 text-xs md:text-sm leading-relaxed space-y-3 mb-6" data-id="element-288">
            <p data-id="element-289">
              Derechos de autor © 2025, Infocommerce AI: Todos los derechos
              reservados.
            </p>
            <p data-id="element-290">
              Este sitio no forma parte del sitio web de Facebook™ ni de
              Facebook™ Inc. Además, este sitio NO está respaldado por
              Facebook™ de ninguna manera. FACEBOOK™ es una marca registrada
              de FACEBOOK™, Inc.
            </p>
            <p className="text-gray-500" data-id="element-291">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400 transition-colors" data-id="element-292">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-sm" data-id="element-293">
              <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors underline" data-id="element-294">
                Términos
              </button>
              <span data-id="element-295">|</span>
              <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors underline" data-id="element-296">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-297">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-298">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-299">
              <X className="w-6 h-6" data-id="element-300" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-301">
              Términos y Condiciones
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-302">
              <p data-id="element-303">
                Al registrarte y participar en el AI Infocommerce Masterclass,
                aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-304">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-305">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-306">
                2. Uso del Servicio
              </h3>
              <p data-id="element-307">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-308">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-309">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de Infocommerce AI y están protegidos por derechos de
                autor. No está permitida la reproducción o distribución sin
                autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-310">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-311">
                Infocommerce AI no será responsable de ningún daño directo,
                indirecto, incidental o consecuente que resulte del uso o la
                imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-312">
                5. Modificaciones
              </h3>
              <p data-id="element-313">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-314">Contacto</h3>
              <p data-id="element-315">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-316">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-317">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-318">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-319">
              <X className="w-6 h-6" data-id="element-320" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-321">
              Política de Privacidad
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-322">
              <p data-id="element-323">
                En Infocommerce AI, nos comprometemos a proteger tu privacidad.
                Esta política describe cómo recopilamos, usamos y protegemos tu
                información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-324">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-325">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-326">
                <li data-id="element-327">Nombre y dirección de correo electrónico</li>
                <li data-id="element-328">Información de registro del evento</li>
                <li data-id="element-329">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-330">
                2. Uso de la Información
              </h3>
              <p data-id="element-331">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-332">
                <li data-id="element-333">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-334">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-335">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-336">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-337">
                3. Compartir Información
              </h3>
              <p data-id="element-338">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-339">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-340">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-341">
                5. Tus Derechos
              </h3>
              <p data-id="element-342">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-343">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-344">6. Cookies</h3>
              <p data-id="element-345">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-346">Contacto</h3>
              <p data-id="element-347">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-348">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}